<template>
  <div class="date-range-picker">
    <byted-range-picker
      :offset="offset"
      v-model="dateRange"
      format="YYYY-MM-DD"
      value-format="YYYY-MM-DD"
      :popper-options="{placement: 'bottom-end', modifiers: { offset: {offset: 0}}}"
      :disabled-date="disabledDate"
      @change="changeHandler"
      :shortcuts="shortcuts"
    />
  </div>
</template>

<script>
import { dayStr } from 'Src/const/state/common';
import dayjs from 'dayjs'
const shortcuts = [
  {
    text: $bp_t('今天', 'common.today'),
    value: [dayStr.today, dayStr.today],
    onClick: () => {}
  },
  {
    text: $bp_t('昨天', 'common.yesterday'),
    value: [dayStr.before_1, dayStr.before_1],
    onClick: () => {}
  },
  {
    text: $bp_t('过去7天', 'common.past_days'),
    value: [dayStr.before_7, dayStr.before_1],
    onClick: () => {}
  },
  {
    text: $bp_t('过去30天', 'common.past_month'),
    value: [dayStr.before_30, dayStr.before_1],
    onClick: () => {}
  },
  {
    text: $bp_t('本周', 'common.this_week'),
    value: [dayStr.week_start, dayStr.week_end],
    onClick: () => {}
  },
  {
    text: $bp_t('上周', 'common.last_week'),
    value: [dayStr.pre_week_start, dayStr.pre_week_end],
    onClick: () => {}
  },
  {
    text: $bp_t('本月', 'common.this_month'),
    value: [dayStr.month_start, dayStr.month_end],
    onClick: () => {}
  },
  {
    text: $bp_t('上月', 'common.last_month'),
    value: [dayStr.pre_month_start, dayStr.pre_month_end],
    onClick: () => {}
  }
];

export default {
  name: 'range-picker',
  props: {
    value: {
      type: Object,
      default: () => ({
        et: dayStr.week_end,
        st: dayStr.week_start,
      })
    },
    // 回溯截止时间
    notBeforeDate: {
      type: String,
      default: dayStr.before_10_years
    },
    notAfterDate: {
      type: String,
      default: dayStr.today
    },
    offset: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      dateRange: [],
    }
  },
  computed: {
    shortcuts() {
      // 有偏移时不提供shorcuts
      if (this.offset !== 0) {
        return undefined;
      }
      // 如果最晚时间为大前天，则不提供shortcuts能力
      if (dayjs(this.notAfterDate).isBefore(dayjs(dayStr.before_1))) {
        return undefined;
      }
      return shortcuts
    }
  },
  mounted() {
    this.dateRange = [this.value.st, this.value.et];
  },
  watch: {
    offset() {
      this.dateRange = [this.value.st, this.value.et]
    }
  },
  methods: {
    changeHandler(e) {
      this.$emit('valueChanged', {st: this.dateRange[0], et: this.dateRange[1]})
    },
    disabledDate({ current, type }) {
      let notBeforeDate = this.notBeforeDate
      let notAfterDate = this.notAfterDate
      if (type === 'year') {
        // 在最后一天之前，在第一天之后存在日期就可选
        notBeforeDate = dayjs(notBeforeDate).startOf('year')
        notAfterDate = dayjs(notAfterDate).endOf('year')
      } else if (type === 'month') {
        notBeforeDate = dayjs(notBeforeDate).startOf('month')
        notAfterDate = dayjs(notAfterDate).endOf('month')
      }
      return current.isBefore(notBeforeDate) || current.isAfter(notAfterDate)
    }
  }
};
</script>

<style lang="scss" scoped>
.byted-range-picker {
  width: 260px;
  cursor: pointer;

  /deep/ .bui-range-picker-input {
    text-align: center;
    cursor: pointer;
  }
}
</style>
